"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
require("react");
require("../../../../foundations/icons/IconsDefault.js");
const foundations_typography_Text_Text = require("../../../../foundations/typography/Text/Text.js");
const ToggletipDescription = (props) => /* @__PURE__ */ jsxRuntime.jsx(foundations_typography_Text_Text.Text, { variant: "caption", component: "p", ...props });
exports.ToggletipDescription = ToggletipDescription;
